import React, { Component, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import withNavigate from "../../components/withNavigate";
import ClusterService from "../../services/api/cluster";
import ProvisionerService from "../../services/api/Provisioner";
import toast from "react-hot-toast";
import {
  API_RESPONSE,
  CLUSTERSTATUS,
  websocketAction,
  provisionerService,
  hasHTMLTags,
  default_size,
} from "../../settings/shared/constants";
import moment from "moment";
import SATooltip from "../../components/common/SATooltip";
import {
  convertTextToTitleCase,
  provisionerTypeLogo,
  checkSpecialChar,
} from "../../settings/shared/commonMethods";
import SAModalConfirm from "../../components/common/SAModalConfirm";
import SAPagination from "../../components/common/SAPagination";
import { cloud, cluster } from "../../settings/shared/CommonMessages";
import { showNotificationGlobal } from "../../components/common/NotificationProvider";

/* ─────────────────────────────────────────────────────────────
   Icons (inline SVG — no extra deps)
───────────────────────────────────────────────────────────── */
const Ic = {
  Search: () => (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <circle cx="6.5" cy="6.5" r="5" stroke="currentColor" strokeWidth="1.5" />
      <line x1="10.5" y1="10.5" x2="14" y2="14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  Plus: () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <line x1="6" y1="1" x2="6" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="1" y1="6" x2="11" y2="6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  Close: () => (
    <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
      <line x1="1" y1="1" x2="11" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="11" y1="1" x2="1" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  ChevDown: () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <polyline points="2,3.5 5,6.5 8,3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ChevUp: () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <polyline points="2,6.5 5,3.5 8,6.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ChevLeft: () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <polyline points="6,2 3,5 6,8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  ChevRight: () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <polyline points="4,2 7,5 4,8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Dots: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle cx="7" cy="2.5" r="1.2" fill="currentColor" />
      <circle cx="7" cy="7" r="1.2" fill="currentColor" />
      <circle cx="7" cy="11.5" r="1.2" fill="currentColor" />
    </svg>
  ),
  Refresh: () => (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
    <path
      d="M13.5 2.5v4h-4"
      stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"
    />
    <path
      d="M13.5 6.5A6 6 0 1 0 11.5 11"
      stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"
    />
  </svg>
  ),
  Server: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <rect x="1" y="2" width="16" height="5" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
      <rect x="1" y="11" width="16" height="5" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="14" cy="4.5" r="1" fill="currentColor" />
      <circle cx="14" cy="13.5" r="1" fill="currentColor" />
    </svg>
  ),
  Cloud: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M13.5 13H5a4 4 0 1 1 .6-7.9A5 5 0 0 1 14 8a3.5 3.5 0 0 1-.5 5z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    </svg>
  ),
  Shield: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M9 2l6 2.5V9c0 3.5-2.5 6-6 7C3 15 .5 12.5.5 9V4.5L9 2z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    </svg>
  ),
  Check: () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <polyline points="1.5,6 4.5,9 10.5,2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Info: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.2" />
      <line x1="7" y1="6" x2="7" y2="10" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="7" cy="4" r="0.7" fill="currentColor" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
      <polyline points="9,2 4,7 9,12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  PlusSquare: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="2" y="2" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.3" />
      <path d="M8 5.5v5M5.5 8h5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  ),
  MinusSquare: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="2" y="2" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.3" />
      <path d="M5.5 8h5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  ),
  SortAsc: () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M5 2.2L8 6.8H2L5 2.2Z" fill="currentColor" />
    </svg>
  ),
  SortDesc: () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M5 7.8L2 3.2h6L5 7.8Z" fill="currentColor" />
    </svg>
  ),
  SortIdle: () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M5 1.8L7.2 4.4H2.8L5 1.8Z" fill="currentColor" opacity="0.35" />
      <path d="M5 8.2L2.8 5.6h4.4L5 8.2Z" fill="currentColor" opacity="0.35" />
    </svg>
  ),
};

const CLUSTER_LIST_GRID_COLUMNS =
  "28px minmax(160px, 1.6fr) minmax(110px, 0.95fr) minmax(80px, 0.7fr) minmax(72px, 0.6fr) minmax(100px, 0.9fr) minmax(100px, 0.9fr) 48px";

function SortableHead({ label, sortKey, activeKey, sortDir, onSort, align = "left" }) {
  const active = activeKey === sortKey;
  return (
    <button
      type="button"
      className="cl-sort-btn"
      onClick={() => onSort(sortKey)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: 0,
        border: "none",
        background: "transparent",
        cursor: "pointer",
        font: "inherit",
        color: active ? T.textPrimary : "inherit",
        justifyContent: align === "right" ? "flex-end" : "flex-start",
        width: "100%",
        textTransform: "inherit",
        letterSpacing: "inherit",
        fontWeight: active ? 700 : "inherit",
      }}
    >
      <span>{label}</span>
      <span style={{ display: "inline-flex", color: active ? T.accent : T.textMuted }}>
        {active ? (sortDir === "asc" ? <Ic.SortAsc /> : <Ic.SortDesc />) : <Ic.SortIdle />}
      </span>
    </button>
  );
}

function ClusterListSkeleton({ rows = 5 }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }} aria-hidden="true">
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={`cluster-skeleton-${index}`}
          className="cl-cluster-row cl-list-row--skeleton"
          style={{
            background: T.surface,
            border: `1px solid ${T.border}`,
            borderRadius: 12,
            padding: "14px 16px",
          }}
        >
          <span className="cl-skel cl-skel-chevron" />
          <span className="cl-skel cl-skel-name" />
          <span className="cl-skel cl-skel-chip" />
          <span className="cl-skel cl-skel-chip" />
          <span className="cl-skel cl-skel-chip-sm" />
          <span className="cl-skel cl-skel-text" />
          <span className="cl-skel cl-skel-text" />
          <span className="cl-skel cl-skel-action" />
        </div>
      ))}
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   Design tokens & styles
───────────────────────────────────────────────────────────── */
const T = {
  navy: "#0f172a",
  themePrimary: "var(--activemenu, #3d91e4)",
  navyLight: "#1e293b",
  accent: "#3b82f6",
  accentDark: "#1d4ed8",
  border: "rgba(0,0,0,0.07)",
  borderMid: "rgba(0,0,0,0.12)",
  bg: "#f8fafc",
  surface: "#ffffff",
  textPrimary: "#0f172a",
  textSecondary: "#64748b",
  textMuted: "#94a3b8",
  fontMono: "'DM Mono','Courier New',monospace",
  fontSans: "'DM Sans','Segoe UI',sans-serif",
};

const STATUS_STYLE = {
  running:      { bg: "#dcfce7", color: "#166534" },
  active:      { bg: "#dcfce7", color: "#166534" },
  starting:     { bg: "#fef9c3", color: "#854d0e" },
  pending:      { bg: "#fef9c3", color: "#854d0e" },
  creating:     { bg: "#fef9c3", color: "#854d0e" },
  provisioning: { bg: "#fef9c3", color: "#854d0e" },
  restarting:   { bg: "#fef9c3", color: "#854d0e" },
  failed:       { bg: "#fee2e2", color: "#991b1b" },
  error:        { bg: "#fee2e2", color: "#991b1b" },
  deleted:      { bg: "#fee2e2", color: "#991b1b" },
  deleting:     { bg: "#fee2e2", color: "#991b1b" },
  stopped:      { bg: "#f1f5f9", color: "#475569" },
  stopping:     { bg: "#f1f5f9", color: "#475569" },
  unknown:      { bg: "#f1f5f9", color: "#475569" },
  not_found:    { bg: "#f1f5f9", color: "#475569" },
};

function getStatusStyle(status) {
  return STATUS_STYLE[(status || "").toLowerCase()] || { bg: "#fef3c7", color: "#92400e" };
}

function DetailChip({ children, tone = "neutral" }) {
  const tones = {
    neutral: { bg: "#f1f5f9", color: T.textSecondary },
    success: { bg: "#dcfce7", color: "#166534" },
    warning: { bg: "#fef9c3", color: "#854d0e" },
    info: { bg: "#eff6ff", color: "#1d4ed8" },
  };
  const t = tones[tone] || tones.neutral;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        background: t.bg,
        color: t.color,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
}

function DetailField({ label, value, mono = false }) {
  const empty = value === undefined || value === null || value === "";
  return (
    <div
      style={{
        background: "#fff",
        border: `0.5px solid ${T.border}`,
        borderRadius: 10,
        padding: "12px 14px",
        minHeight: 64,
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontWeight: 650,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          color: T.textMuted,
          marginBottom: 6,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: 13,
          fontWeight: 500,
          color: empty ? T.textMuted : T.textPrimary,
          fontFamily: mono ? T.fontMono : T.fontSans,
          wordBreak: "break-word",
          lineHeight: 1.4,
        }}
        title={empty ? undefined : String(value)}
      >
        {empty ? "—" : String(value)}
      </div>
    </div>
  );
}

function ClusterAvatar({ name, provisionerType }) {
  const initial = String(name || "C").trim().charAt(0).toUpperCase();
  return (
    <div
      style={{
        width: 42,
        height: 42,
        borderRadius: 11,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(145deg, #eff6ff 0%, #f8fafc 100%)",
        color: T.accent,
        border: `1px solid ${T.border}`,
        position: "relative",
      }}
    >
      <span style={{ fontSize: 14, fontWeight: 700, letterSpacing: "-0.02em" }}>{initial}</span>
      <span
        style={{
          position: "absolute",
          right: -3,
          bottom: -3,
          width: 18,
          height: 18,
          borderRadius: 6,
          background: T.surface,
          border: `1px solid ${T.border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <img src={provisionerTypeLogo(provisionerType)} alt="" style={{ width: 12, height: 12, objectFit: "contain" }} />
      </span>
    </div>
  );
}

function ClusterExpandPanel({ item }) {
  const providerName = item?.provisionerInfoDTO?.name || item?.cloudProvider || "—";
  const st = getStatusStyle(item?.clusterStatus);
  const idleLabel = item?.idleSecs
    ? (Number(item.idleSecs) >= 3600
      ? `${Math.round(Number(item.idleSecs) / 3600)} hours`
      : `${item.idleSecs}s`)
    : null;

  return (
    <div className="cl-expand-panel" onClick={(e) => e.stopPropagation()}>
      <div className="cl-expand-meta">
        <div className="cl-expand-meta-item">
          <div className="cl-expand-meta-label">Status</div>
          <div className="cl-expand-meta-value">
            <span className="cl-meta-chip" style={{ background: st.bg, color: st.color, borderColor: "rgba(0,0,0,0.05)" }}>
              {convertTextToTitleCase(item?.clusterStatus) || "Unknown"}
            </span>
          </div>
        </div>
        <div className="cl-expand-meta-item">
          <div className="cl-expand-meta-label">Provider</div>
          <div className="cl-expand-meta-value">{providerName}</div>
        </div>
        <div className="cl-expand-meta-item">
          <div className="cl-expand-meta-label">Created</div>
          <div className="cl-expand-meta-value">
            {item?.createdDate ? moment(item.createdDate).format("MMM DD, YYYY · hh:mm A") : "—"}
          </div>
        </div>
        <div className="cl-expand-meta-item">
          <div className="cl-expand-meta-label">Autoscale</div>
          <div className="cl-expand-meta-value">
            <DetailChip tone={item?.autoscale ? "success" : "neutral"}>
              {item?.autoscale ? "On" : "Off"}
            </DetailChip>
          </div>
        </div>
      </div>

      {item?.description?.trim() && (
        <div className="cl-expand-section">
          <div style={{ fontSize: 12, fontWeight: 600, color: T.textPrimary, marginBottom: 6 }}>Description</div>
          <div style={{ fontSize: 12, color: T.textSecondary, lineHeight: 1.5 }}>{item.description.trim()}</div>
        </div>
      )}

      <div className="cl-expand-section">
        <div style={{ fontSize: 12, fontWeight: 600, color: T.textPrimary, marginBottom: 10 }}>Infrastructure</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 10 }} className="cl-expand-grid">
          <DetailField label="Zone" value={item?.zone} />
          <DetailField label="Compute instance" value={item?.computeInstance} mono />
          <DetailField label="Nodes" value={item?.nodeCount} mono />
          <DetailField label="Cost" value={item?.cost != null ? `₹${item.cost}` : null} mono />
        </div>
      </div>

      <div className="cl-expand-section">
        <div style={{ fontSize: 12, fontWeight: 600, color: T.textPrimary, marginBottom: 10 }}>Network</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 10 }} className="cl-expand-grid">
          <DetailField label="VPC ID" value={item?.vpcId} mono />
          <DetailField label="Subnet ID" value={item?.subnetId} mono />
          <DetailField label="Region" value={item?.region} />
          <DetailField label="Cloud provider" value={providerName} />
        </div>
      </div>

      <div className="cl-expand-section">
        <div style={{ fontSize: 12, fontWeight: 600, color: T.textPrimary, marginBottom: 10 }}>Lifecycle</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 10 }} className="cl-expand-grid">
          <DetailField label="Aging policy" value={item?.agingPolicy} />
          <DetailField label="If idle" value={idleLabel} />
          <DetailField label="Created by" value={item?.createdBy} />
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   Shared UI primitives
───────────────────────────────────────────────────────────── */

/** Thin text input / select */
function Field({ label, required, error, hint, children }) {
  return (
    <div style={{ marginBottom: 18 }}>
      {label && (
        <label style={{ display: "block", fontSize: 11, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", color: T.textSecondary, marginBottom: 6 }}>
          {label} {required && <span style={{ color: "#dc2626" }}>*</span>}
        </label>
      )}
      {children}
      {error && <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>{error}</div>}
      {hint && !error && <div style={{ fontSize: 11, color: T.textMuted, marginTop: 4 }}>{hint}</div>}
    </div>
  );
}

function Input({ error, style, ...rest }) {
  return (
    <input
      {...rest}
      style={{
        width: "100%",
        height: 36,
        padding: "0 12px",
        border: error ? "0.5px solid #dc2626" : `0.5px solid ${T.borderMid}`,
        borderRadius: 8,
        background: "#f8fafc",
        fontFamily: T.fontSans,
        fontSize: 13,
        color: T.textPrimary,
        outline: "none",
        boxSizing: "border-box",
        ...style,
      }}
    />
  );
}

function Select({ error, style, children, ...rest }) {
  return (
    <select
      {...rest}
      style={{
        width: "100%",
        height: 36,
        padding: "0 12px",
        border: error ? "0.5px solid #dc2626" : `0.5px solid ${T.borderMid}`,
        borderRadius: 8,
        background: "#f8fafc",
        fontFamily: T.fontSans,
        fontSize: 13,
        color: T.textPrimary,
        outline: "none",
        cursor: "pointer",
        boxSizing: "border-box",
        ...style,
      }}
    >
      {children}
    </select>
  );
}

/** Shared custom dropdown (same UI as provider select) */
function SpecChip({ label, tone = "neutral" }) {
  const tones = {
    vcpu: { bg: "#e0f2fe", color: "#0369a1", border: "#bae6fd" },
    memory: { bg: "#fef3c7", color: "#b45309", border: "#fde68a" },
    cores: { bg: "#d1fae5", color: "#047857", border: "#a7f3d0" },
    neutral: { bg: "#f1f5f9", color: "#64748b", border: "rgba(0,0,0,0.05)" },
  };
  const t = tones[tone] || tones.neutral;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "2px 7px",
        borderRadius: 6,
        fontSize: 10,
        fontWeight: 650,
        letterSpacing: "0.01em",
        whiteSpace: "nowrap",
        background: t.bg,
        color: t.color,
        border: `1px solid ${t.border}`,
      }}
    >
      {label}
    </span>
  );
}

function OptionContent({ option, active = false, compact = false }) {
  const specs = option?.specs || [];
  return (
    <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: compact ? "row" : "column", alignItems: compact ? "center" : "flex-start", gap: compact ? 8 : 5 }}>
      <span
        style={{
          fontSize: 13,
          fontWeight: active ? 600 : 500,
          color: T.textPrimary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: compact && specs.length ? "42%" : "100%",
        }}
      >
        {option?.label}
      </span>
      {specs.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4, minWidth: 0 }}>
          {specs.map((spec) => (
            <SpecChip key={`${spec.tone}-${spec.label}`} label={spec.label} tone={spec.tone} />
          ))}
        </div>
      )}
    </div>
  );
}

function FancySelect({
  value,
  options = [],
  onChange,
  error = false,
  placeholder = "Select…",
  emptyMessage = "No options available",
  divided = false,
}) {
  const [open, setOpen] = useState(false);
  const [menuPos, setMenuPos] = useState(null);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const selected = options.find((o) => String(o?.value) === String(value));

  const updateMenuPos = () => {
    const rect = buttonRef.current?.getBoundingClientRect();
    if (!rect) return;
    setMenuPos({
      top: rect.bottom + 4,
      left: rect.left,
      width: Math.max(rect.width, 280),
    });
  };

  useEffect(() => {
    if (!open) return undefined;
    updateMenuPos();
    const onPointerDown = (e) => {
      if (!containerRef.current?.contains(e.target) && !e.target?.closest?.(".cl-fancy-select-menu")) {
        setOpen(false);
      }
    };
    const onReposition = () => updateMenuPos();
    document.addEventListener("mousedown", onPointerDown);
    window.addEventListener("resize", onReposition);
    window.addEventListener("scroll", onReposition, true);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      window.removeEventListener("resize", onReposition);
      window.removeEventListener("scroll", onReposition, true);
    };
  }, [open]);

  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setOpen((p) => !p)}
        style={{
          width: "100%",
          minHeight: 40,
          padding: "6px 12px",
          display: "flex",
          alignItems: "center",
          gap: 10,
          border: error ? "0.5px solid #dc2626" : `0.5px solid ${T.borderMid}`,
          borderRadius: 8,
          background: error ? "#fff1f2" : "#f8fafc",
          fontFamily: T.fontSans,
          fontSize: 13,
          color: selected ? T.textPrimary : T.textMuted,
          cursor: "pointer",
          boxSizing: "border-box",
          textAlign: "left",
        }}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {selected ? (
          <>
            {selected.image ? (
              <img
                src={selected.image}
                alt=""
                style={{ width: 22, height: 22, objectFit: "contain", flexShrink: 0 }}
              />
            ) : null}
            <OptionContent option={selected} active compact />
          </>
        ) : (
          <span style={{ flex: 1 }}>{placeholder}</span>
        )}
        <span style={{ color: T.textMuted, fontSize: 11, transform: open ? "rotate(180deg)" : "none", transition: "transform 0.15s" }}>
          ▼
        </span>
      </button>

      {open && menuPos && createPortal(
        <div
          className="cl-fancy-select-menu"
          role="listbox"
          style={{
            position: "fixed",
            zIndex: 10060,
            top: menuPos.top,
            left: menuPos.left,
            width: menuPos.width,
            maxHeight: 280,
            overflowY: "auto",
            background: T.surface,
            border: `0.5px solid ${T.borderMid}`,
            borderRadius: 10,
            boxShadow: "0 10px 28px rgba(15,23,42,0.12)",
            padding: 6,
          }}
        >
          {options.length === 0 ? (
            <div style={{ padding: "10px 12px", fontSize: 12, color: T.textMuted }}>{emptyMessage}</div>
          ) : (
            options.map((opt, index) => {
              const active = String(opt?.value) === String(value);
              const isLast = index === options.length - 1;
              return (
                <div key={String(opt.value)}>
                  <button
                    type="button"
                    role="option"
                    aria-selected={active}
                    onClick={() => {
                      onChange(opt.value);
                      setOpen(false);
                    }}
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      padding: divided ? "10px 10px" : "8px 10px",
                      border: "none",
                      borderRadius: 8,
                      background: active ? "#eff6ff" : "transparent",
                      cursor: "pointer",
                      fontFamily: T.fontSans,
                      textAlign: "left",
                    }}
                  >
                    {opt.image ? (
                      <img
                        src={opt.image}
                        alt=""
                        style={{ width: 22, height: 22, objectFit: "contain", flexShrink: 0 }}
                      />
                    ) : null}
                    <OptionContent option={opt} active={active} />
                    {active && <Ic.Check />}
                  </button>
                  {divided && !isLast && (
                    <div
                      style={{
                        height: 1,
                        background: "rgba(15, 23, 42, 0.08)",
                        margin: "2px 8px",
                      }}
                    />
                  )}
                </div>
              );
            })
          )}
        </div>,
        document.body
      )}
    </div>
  );
}

function ProviderSelect({
  value,
  options = [],
  onChange,
  error = false,
  placeholder = "Select a cloud provider",
  emptyMessage = "No providers available",
}) {
  const mapped = options.map((provider) => ({
    value: provider.id,
    label: provider.name,
    image: provisionerTypeLogo(provider.provisionerType),
  }));

  return (
    <FancySelect
      value={value}
      options={mapped}
      onChange={onChange}
      error={error}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
    />
  );
}

function getClusterStepErrors(step, state) {
  const errors = [];
  if (step === 1) {
    if (!String(state.name || "").trim() || !checkSpecialChar(state.name)) {
      errors.push("name");
    }
  }
  if (step === 2) {
    if (!state.provisionerId) errors.push("provisionerId");
    if (!state.zone) errors.push("zone");
    if (!state.computeInstance) errors.push("computeInstance");
    const nodes = parseInt(state.nodeCount, 10);
    if (!nodes || nodes < 1) errors.push("nodeCount");
  }
  return errors;
}

function Textarea({ style, ...rest }) {
  return (
    <textarea
      {...rest}
      style={{
        width: "100%",
        padding: "8px 12px",
        border: `0.5px solid ${T.borderMid}`,
        borderRadius: 8,
        background: "#f8fafc",
        fontFamily: T.fontSans,
        fontSize: 13,
        color: T.textPrimary,
        outline: "none",
        resize: "vertical",
        boxSizing: "border-box",
        ...style,
      }}
    />
  );
}

function BtnPrimary({ children, style, ...rest }) {
  return (
    <button
      {...rest}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        background: T.themePrimary,
        color: "#fff",
        border: "none",
        borderRadius: 8,
        padding: "0 16px",
        height: 36,
        fontFamily: T.fontSans,
        fontSize: 13,
        fontWeight: 500,
        cursor: "pointer",
        ...style,
      }}
    >
      {children}
    </button>
  );
}

function BtnSecondary({ children, style, ...rest }) {
  return (
    <button
      {...rest}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        background: "transparent",
        color: T.textPrimary,
        border: `0.5px solid ${T.borderMid}`,
        borderRadius: 8,
        padding: "0 14px",
        height: 36,
        fontFamily: T.fontSans,
        fontSize: 13,
        cursor: "pointer",
        ...style,
      }}
    >
      {children}
    </button>
  );
}

function InfoBox({ children }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 10,
        alignItems: "flex-start",
        background: "#eff6ff",
        border: "0.5px solid #bfdbfe",
        borderRadius: 8,
        padding: "12px 14px",
        marginTop: 16,
        fontSize: 12,
        color: "#1e40af",
        lineHeight: 1.6,
      }}
    >
      <span style={{ flexShrink: 0, marginTop: 1 }}>
        <Ic.Info />
      </span>
      <div>{children}</div>
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   Stepper
───────────────────────────────────────────────────────────── */
const STEPS = [
  { label: "General", hint: "Name & description", icon: <Ic.Server /> },
  { label: "Cloud", hint: "Provider & capacity", icon: <Ic.Cloud /> },
  { label: "Network", hint: "VPC & policies", icon: <Ic.Shield /> },
];

function Stepper({ current }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 0, padding: "8px 0" }}>
      {STEPS.map((step, i) => {
        const done = i + 1 < current;
        const active = i + 1 === current;
        return (
          <div
            key={i}
            style={{
              display: "grid",
              gridTemplateColumns: "36px 1fr",
              gap: 12,
              alignItems: "stretch",
              padding: "4px 8px",
              borderRadius: 12,
              background: active ? "#eff6ff" : "transparent",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: done ? "#dcfce7" : active ? T.themePrimary : "#e2e8f0",
                  color: done ? "#15803d" : active ? "#fff" : T.textMuted,
                  transition: "background 0.2s",
                  fontSize: 13,
                  flexShrink: 0,
                  boxShadow: active ? "0 0 0 3px rgba(59,130,246,0.16)" : "none",
                }}
              >
                {done ? <Ic.Check /> : step.icon}
              </div>
              {i < STEPS.length - 1 && (
                <div
                  style={{
                    width: 2,
                    flex: 1,
                    minHeight: 20,
                    margin: "6px 0 2px",
                    borderRadius: 999,
                    background: done ? T.themePrimary : "#e2e8f0",
                    transition: "background 0.2s",
                  }}
                />
              )}
            </div>
            <div style={{ padding: "8px 4px 18px 0" }}>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: active ? 650 : 500,
                  color: active ? T.textPrimary : T.textSecondary,
                  letterSpacing: "0.2px",
                }}
              >
                {step.label}
              </div>
              <div style={{ fontSize: 11, color: T.textMuted, marginTop: 2, lineHeight: 1.35 }}>
                {step.hint}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

/* ─────────────────────────────────────────────────────────────
   Main Component
───────────────────────────────────────────────────────────── */
class ClusterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clusterData: [],
      provisonerData: [],
      totalPages: 0,
      loading: false,
      currentPage: 0,
      pageSize: 10,
      actionShow: false,
      websocketRefresh: false,
      searchValue: "",
      sortKey: null,
      sortDir: null,
      expandedRows: {},
      actionType: "",
      actionTitle: "",
      actionmessage: "",
      selectedItem: null,
      // Create cluster panel
      showClusterAction: false,
      provisionerNames: [],
      currentStep: 1,
      submitFlag: false,
      name: "",
      description: "",
      cloudProvider: "",
      region: "",
      zoneNames: [],
      instanceNames: [],
      zone: "",
      computeInstance: "",
      nodeCount: 1,
      autoscale: false,
      provisionerId: "",
      provisionerInfoDTO: { name: "", provisionerType: "", provisionerStatus: "" },
      vpcId: "",
      subnetId: "",
      agingPolicy: "TERMINATE",
      idleSecs: 0,
      idleAction: "",
      // Dropdown open state per row
      openDropdown: null,
      dropdownPos: null,
      creating: false,
    };

    this._isMounted = false;
    this.abortController = null;
    this.searchDebounceTimer = null;
  }

  componentDidMount() {
    this._isMounted = true;
    this.getClusterList();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("clusterMessageReceived", this.handlerMessageReceived);
    document.addEventListener("click", this.handleOutsideClick);
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.abortController) this.abortController.abort();
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
    window.removeEventListener("resize", this.updateWindowDimensions);
    window.removeEventListener("clusterMessageReceived", this.handlerMessageReceived);
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick = () => {
    this.closeDropdown();
  };

  handlerMessageReceived = (event) => {
    const message = event?.detail;
    if (message?.ninfo?.action === websocketAction.REFRESH) {
      this.setState({ websocketRefresh: true }, () => this.getClusterList());
    }
  };

  updateWindowDimensions = () => this.setState({ height: window.innerHeight });

  /* ── API ── */
  getClusterList = () => {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();
    if (!this.state.websocketRefresh) this.setState({ loading: true });

    ClusterService.getClusterList(0, default_size)
      .then((response) => {
        if (!this._isMounted) return;
        if (response?.status === API_RESPONSE.SUCCESS) {
          const page = response.k8sClusterDTOPage || {};
          this.setState({
            clusterData: page.content || [],
            loading: false,
            websocketRefresh: false,
          });
        } else {
          this.setState({ loading: false, websocketRefresh: false });
          toast.error(response?.errorMessage || "Failed to load clusters");
        }
      })
      .catch((error) => {
        if (!this._isMounted || error.name === "AbortError") return;
        this.setState({ loading: false, websocketRefresh: false });
        toast.error("Error loading clusters. Please try again.");
        console.error(error);
      });
  };

  handlePaginationClick = (pageNumber) => {
    if (pageNumber === this.state.currentPage) return;
    this.setState({
      currentPage: pageNumber,
      expandedRows: {},
      openDropdown: null,
      dropdownPos: null,
    });
  };

  getProvisionerByService = async () => {
    return ProvisionerService.getProvisionerByService(provisionerService.containerCluster)
      .then((response) => {
        if (!this._isMounted) return;
        if (response?.status === API_RESPONSE.SUCCESS) {
          const contents = response?.provisionerDTOPage?.content || [];
          if (contents.length === 0) {
            this.setState({ provisionerNames: [] });
            return;
          }

          const firstProvider = contents[0];
          const shouldSelectDefault = !this.state.provisionerId;

          this.setState(
            (prev) => ({
              provisionerNames: contents,
              ...(shouldSelectDefault
                ? {
                    provisionerId: firstProvider?.id || "",
                    provisionerInfoDTO: {
                      ...prev.provisionerInfoDTO,
                      name: firstProvider?.name || "",
                      provisionerStatus: firstProvider?.provisionerStatus || "",
                      provisionerType: firstProvider?.provisionerType || "",
                    },
                  }
                : {}),
            }),
            () => {
              if (shouldSelectDefault && firstProvider?.provisionerType) {
                this.getZones(firstProvider.provisionerType);
              }
            }
          );
        } else {
          toast.error(response?.errorMessage || "Failed to load provisioners");
        }
      })
      .catch((error) => {
        if (!this._isMounted) return;
        toast.error("Error loading provisioners.");
        console.error(error);
      });
  };

  getZones = (provisionerType) => {
    if (!provisionerType) {
      this.setState({ zoneNames: [], instanceNames: [] });
      return;
    }

    this.setState({ zoneNames: [], instanceNames: [], zone: "", computeInstance: "" });

    ProvisionerService.getZones(provisionerType)
      .then((response) => {
        if (!this._isMounted) return;

        const candidates = [
          response?.data,
          response,
          response?.data?.data,
          response?.instanceTypeDTO,
          response?.data?.instanceTypeDTO,
        ].filter(Boolean);

        let regions = [];
        let specs = [];
        for (const candidate of candidates) {
          const nextRegions =
            candidate?.instanceTypeRegionDTOS ||
            candidate?.instanceTypeRegionDTOs ||
            candidate?.zones ||
            null;
          const nextSpecs =
            candidate?.instanceTypeSpecDTOS ||
            candidate?.instanceTypeSpecDTOs ||
            candidate?.instanceTypes ||
            null;
          if (Array.isArray(nextRegions) || Array.isArray(nextSpecs)) {
            regions = Array.isArray(nextRegions) ? nextRegions : [];
            specs = Array.isArray(nextSpecs) ? nextSpecs : [];
            break;
          }
        }

        const hasCatalog = regions.length > 0 || specs.length > 0;
        if (response?.status && response.status !== API_RESPONSE.SUCCESS && !hasCatalog) {
          toast.error(response?.errorMessage || "Failed to load zones and instance types");
          this.setState({ zoneNames: [], instanceNames: [] });
          return;
        }

        const zoneNames = regions
          .map((item) => ({
            value: item?.region || item?.value || "",
            label: item?.displayName || item?.description || item?.region || item?.label || "Unknown region",
          }))
          .filter((item) => item.value);

        const instanceNames = specs
          .map((item) => {
            const type = item?.instanceType || item?.value || "";
            const specsMeta = [];
            if (item?.vcPUs != null && item?.vcPUs !== "") {
              specsMeta.push({ tone: "vcpu", label: `${item.vcPUs} vCPU` });
            }
            if (item?.memoryGiB != null && item?.memoryGiB !== "") {
              specsMeta.push({ tone: "memory", label: `${item.memoryGiB} GiB` });
            }
            if (item?.cores != null && item?.cores !== "") {
              specsMeta.push({ tone: "cores", label: `${item.cores} core${Number(item.cores) === 1 ? "" : "s"}` });
            }
            return {
              value: type,
              label: type || item?.label || "",
              specs: specsMeta,
            };
          })
          .filter((item) => item.value);

        this.setState({ zoneNames, instanceNames });
      })
      .catch((error) => {
        if (!this._isMounted) return;
        toast.error("Error loading zones and instance types.");
        console.error(error);
        this.setState({ zoneNames: [], instanceNames: [] });
      });
  };

  /* ── Create cluster ── */
  showClusterActionForm = () => {
    this.setState({ showClusterAction: true, currentStep: 1 });
    this.getProvisionerByService();
  };

  hideClusterActionForm = () => {
    this.setState({
      showClusterAction: false,
      currentStep: 1,
      name: "", description: "", cloudProvider: "", region: "",
      zoneNames: [], instanceNames: [], zone: "", computeInstance: "",
      nodeCount: 1, autoscale: false,
      provisionerId: "",
      provisionerInfoDTO: { name: "", provisionerType: "", provisionerStatus: "" },
      vpcId: "", subnetId: "", agingPolicy: "TERMINATE", idleSecs: 0, idleAction: "",
      submitFlag: false,
      creating: false,
    });
  };

  handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState({ [name]: type === "checkbox" ? checked : value });
  };

  getCloudInfo = (provider) => {
    if (!provider) return;
    this.setState((prev) => ({
      provisionerInfoDTO: {
        ...prev.provisionerInfoDTO,
        name: provider.name,
        provisionerStatus: provider?.provisionerStatus,
        provisionerType: provider?.provisionerType,
      },
      provisionerId: provider?.id,
    }));
  };

  handleProviderChange = (selectedId) => {
    const provider = (this.state.provisionerNames || []).find(
      (item) => String(item?.id) === String(selectedId || "")
    );

    if (!provider) {
      this.setState({
        provisionerId: "",
        provisionerInfoDTO: { name: "", provisionerType: "", provisionerStatus: "" },
        zone: "",
        computeInstance: "",
        zoneNames: [],
        instanceNames: [],
      });
      return;
    }

    this.setState(
      (prev) => ({
        provisionerId: provider?.id,
        provisionerInfoDTO: {
          ...prev.provisionerInfoDTO,
          name: provider.name,
          provisionerStatus: provider?.provisionerStatus,
          provisionerType: provider?.provisionerType,
        },
        zone: "",
        computeInstance: "",
      }),
      () => this.getZones(provider?.provisionerType)
    );
  };

  next = () => {
    const errors = getClusterStepErrors(this.state.currentStep, this.state);
    if (errors.length > 0) {
      this.setState({ submitFlag: true });
      if (errors.includes("name")) toast.error("Please enter a valid cluster name");
      else if (errors.includes("provisionerId")) toast.error("Please select a cloud provider");
      else if (errors.includes("zone")) toast.error("Please select a zone");
      else if (errors.includes("computeInstance")) toast.error("Please select a compute instance");
      else if (errors.includes("nodeCount")) toast.error("Please enter a valid number of nodes");
      return;
    }
    this.setState((prev) => ({
      currentStep: Math.min(prev.currentStep + 1, 3),
      submitFlag: false,
    }));
  };

  prev = () =>
    this.setState((prev) => ({
      currentStep: Math.max(prev.currentStep - 1, 1),
      submitFlag: false,
    }));

  sanitizeInput = (input) => (input ? input.trim().replace(/[<>]/g, "") : "");

  CreateCluster = async () => {
    const step1Errors = getClusterStepErrors(1, this.state);
    const step2Errors = getClusterStepErrors(2, this.state);
    const errors = [...step1Errors, ...step2Errors];

    if (errors.length > 0) {
      const targetStep = step1Errors.length ? 1 : 2;
      this.setState({ submitFlag: true, currentStep: targetStep });
      if (errors.includes("name")) toast.error("Please enter a valid cluster name");
      else if (errors.includes("provisionerId")) toast.error("Please select a cloud provider");
      else if (errors.includes("zone")) toast.error("Please select a zone");
      else if (errors.includes("computeInstance")) toast.error("Please select a compute instance");
      else if (errors.includes("nodeCount")) toast.error("Please enter a valid number of nodes");
      return;
    }

    if (hasHTMLTags(this.state.name)) {
      showNotificationGlobal("HTML tags are not allowed in the cluster name", "error", "topCenter");
      return;
    }
    if (this.state.creating) return;

    this.setState({ submitFlag: true, creating: true });

    try {
      const clusterData = {
        name: this.sanitizeInput(this.state.name),
        description: this.sanitizeInput(this.state.description),
        cloudProvider: this.state.cloudProvider,
        region: this.state.region,
        zone: this.state.zone,
        computeInstance: this.state.computeInstance,
        nodeCount: parseInt(this.state.nodeCount, 10) || 1,
        autoscale: this.state.autoscale,
        provisionerId: this.state.provisionerId,
        vpcId: this.sanitizeInput(this.state.vpcId),
        subnetId: this.sanitizeInput(this.state.subnetId),
        agingPolicy: this.state.agingPolicy,
        idleSecs: parseInt(this.state.idleSecs, 10) || 0,
      };
      const response = await ClusterService.createCluster(clusterData);
      if (!this._isMounted) return;
      if (response?.status === API_RESPONSE.SUCCESS) {
        toast.success("Cluster created successfully!");
        this.getClusterList();
        this.hideClusterActionForm();
      } else {
        toast.error(response?.errorMessage || "Failed to create cluster");
      }
    } catch (error) {
      if (!this._isMounted) return;
      toast.error("Error creating cluster. Please try again.");
      console.error(error);
    } finally {
      if (this._isMounted) this.setState({ submitFlag: false, creating: false });
    }
  };

  /* ── Cluster actions ── */
  clusterStatus = (e, clusterId) => {
    e?.stopPropagation();
    if (!clusterId) { toast.error("Invalid cluster ID"); return; }
    ClusterService.clusterStatus(clusterId)
      .then((res) => {
        if (!this._isMounted) return;
        if (res?.status === API_RESPONSE.SUCCESS) {
          const updatedStatus = res?.k8sClusterDTOS?.[0]?.clusterStatus || "Unknown";
          this.setState({
            clusterData: this.state.clusterData.map((c) =>
              c.id === clusterId ? { ...c, clusterStatus: updatedStatus } : c
            ),
          });
        } else {
          toast.error(res?.errorMessage || "Failed to fetch status");
        }
      })
      .catch(() => { if (this._isMounted) toast.error("Error fetching status"); });
  };

  showActionModal = (actionType, selectedItem) => {
    this.setState({
      actionShow: true,
      actionTitle: actionType,
      actionmessage: `Are you sure you want to ${actionType.toLowerCase()} this cluster?`,
      selectedItem,
      actionType,
      openDropdown: null,
      dropdownPos: null,
    });
  };

  clearActionData = () => {
    this.setState({ actionTitle: "", actionmessage: "", selectedItem: null, actionType: "", actionShow: false });
  };

  doAction = () => {
    const { actionType, selectedItem } = this.state;
    const id = selectedItem?.id;
    const map = {
      Stop: () => ClusterService.stopCluster(id),
      Start: () => ClusterService.startCluster(id),
      Restart: () => ClusterService.restartCluster(id),
      Clone: () => ClusterService.cloneCluster(id),
      Delete: () => ClusterService.deleteCluster(id),
      ForceDelete: () => ClusterService.forceDeleteCluster(id),
    };
    this.clearActionData();
    if (!id || !map[actionType]) return;
    map[actionType]()
      .then((res) => {
        if (!this._isMounted) return;
        if (res?.status === API_RESPONSE.SUCCESS) {
          toast.success(`Cluster ${actionType.toLowerCase()}d successfully`);
          this.getClusterList();
        } else {
          toast.error(res?.errorMessage || `Failed to ${actionType.toLowerCase()} cluster`);
        }
      })
      .catch(() => { if (this._isMounted) toast.error("An error occurred. Please try again."); });
  };

  /* ── Search / filter / sort ── */
  handleSearchChange = (e) => this.setState({ searchValue: e.target.value, currentPage: 0 });

  handleSort = (key) => {
    this.setState((prev) => ({
      sortKey: key,
      sortDir: prev.sortKey === key && prev.sortDir === "asc" ? "desc" : "asc",
      currentPage: 0,
    }));
  };

  getClusterSortValue = (item, key) => {
    switch (key) {
      case "name":
        return (item?.name || "").toLowerCase();
      case "status":
        return (item?.clusterStatus || "").toLowerCase();
      case "provider":
        return (
          item?.provisionerInfoDTO?.name ||
          item?.provisionerInfoDTO?.provisionerType ||
          ""
        ).toLowerCase();
      case "cost":
        return Number(item?.cost) || 0;
      case "created":
        return item?.createdDate ? new Date(item.createdDate).getTime() : 0;
      case "createdBy":
        return (item?.createdBy || "").toLowerCase();
      default:
        return "";
    }
  };

  getFilteredClusters = () => {
    const { clusterData, searchValue, sortKey, sortDir } = this.state;
    let list = clusterData;
    if (searchValue.trim()) {
      const q = searchValue.toLowerCase().trim();
      list = clusterData.filter(
        (c) =>
          (c.name || "").toLowerCase().includes(q) ||
          (c.clusterStatus || "").toLowerCase().includes(q) ||
          (c.createdBy || "").toLowerCase().includes(q) ||
          (c.provisionerInfoDTO?.name || "").toLowerCase().includes(q)
      );
    }

    if (!sortKey || !sortDir) return list;

    const direction = sortDir === "desc" ? -1 : 1;
    return [...list].sort((a, b) => {
      const av = this.getClusterSortValue(a, sortKey);
      const bv = this.getClusterSortValue(b, sortKey);
      if (typeof av === "number" && typeof bv === "number") return (av - bv) * direction;
      return String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: "base" }) * direction;
    });
  };

  getPagedClusters = () => {
    const filtered = this.getFilteredClusters();
    const pageSize = this.state.pageSize || 10;
    const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
    const currentPage = Math.min(this.state.currentPage, totalPages - 1);
    const start = currentPage * pageSize;
    return {
      items: filtered.slice(start, start + pageSize),
      totalPages,
      currentPage,
      totalItems: filtered.length,
    };
  };

  toggleRow = (clusterId) => {
    this.setState((prev) => {
      const isOpen = !!prev.expandedRows[clusterId];
      return {
        expandedRows: isOpen ? {} : { [clusterId]: true },
      };
    });
  };

  refreshClusterList = () => {
    this.closeDropdown();
    this.getClusterList();
  };

  toggleDropdown = (e, clusterId) => {
    e.stopPropagation();
    e.preventDefault();
    const rect = e.currentTarget?.getBoundingClientRect?.();
    this.setState((prev) => {
      if (prev.openDropdown === clusterId) {
        return { openDropdown: null, dropdownPos: null };
      }
      const menuWidth = 168;
      const menuApproxHeight = 220;
      const gap = 6;
      let top = (rect?.bottom || 0) + gap;
      let left = (rect?.right || 0) - menuWidth;
      if (typeof window !== "undefined") {
        if (top + menuApproxHeight > window.innerHeight - 8) {
          top = Math.max(8, (rect?.top || 0) - menuApproxHeight - gap);
        }
        left = Math.min(Math.max(8, left), window.innerWidth - menuWidth - 8);
      }
      return {
        openDropdown: clusterId,
        dropdownPos: { top, left },
      };
    });
  };

  closeDropdown = () => {
    if (this.state.openDropdown !== null) {
      this.setState({ openDropdown: null, dropdownPos: null });
    }
  };

  /* ──────────────────────────────────────────
     RENDER: Create Cluster (3-step wizard)
  ────────────────────────────────────────── */
  renderCreateCluster() {
    const { currentStep, submitFlag, provisionerNames, creating } = this.state;
    const errors = submitFlag ? getClusterStepErrors(currentStep, this.state) : [];
    const hasError = (key) => errors.includes(key);

    return (
      <div style={{ fontFamily: T.fontSans, background: T.bg, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <div
          style={{
            background: T.surface,
            borderBottom: `0.5px solid ${T.border}`,
            padding: "0 28px",
            height: 60,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: T.themePrimary, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>
              <Ic.Server />
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, color: T.textPrimary }}>Create Cluster</div>
              <div style={{ fontSize: 11, color: T.textMuted, marginTop: 1 }}>
                Step {currentStep} of 3 · {STEPS[currentStep - 1]?.label}
              </div>
            </div>
          </div>
          <BtnSecondary onClick={this.hideClusterActionForm}>
            <Ic.ArrowLeft /> Back to clusters
          </BtnSecondary>
        </div>

        {/* Body: left vertical stepper + content */}
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "240px minmax(0, 1fr)",
            minHeight: 0,
          }}
        >
          <aside
            style={{
              position: "sticky",
              top: 60,
              alignSelf: "start",
              height: "calc(100vh - 60px)",
              padding: "24px 16px",
              background: T.surface,
              borderRight: `0.5px solid ${T.border}`,
              overflow: "auto",
            }}
          >
            <div style={{ fontSize: 11, fontWeight: 650, letterSpacing: "0.06em", textTransform: "uppercase", color: T.textMuted, margin: "0 8px 12px" }}>
              Steps
            </div>
            <Stepper current={currentStep} />
          </aside>

          <div style={{ padding: "24px 28px 48px", maxWidth: 860, width: "100%", boxSizing: "border-box" }}>

          {/* ─── Step 1: General ─── */}
          {currentStep === 1 && (
            <>
              <div
                style={{
                  background: T.surface,
                  border: `0.5px solid ${T.border}`,
                  borderRadius: 12,
                  overflow: "hidden",
                }}
              >
                <div style={{ padding: "20px 24px 16px", borderBottom: `0.5px solid ${T.border}` }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ color: T.accent }}><Ic.Server /></span>
                    <span style={{ fontSize: 15, fontWeight: 500 }}>General information</span>
                  </div>
                  <p style={{ fontSize: 12, color: T.textMuted, marginTop: 4 }}>Define your cluster basics</p>
                </div>
                <div style={{ padding: 24 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                    <Field
                      label="Name"
                      required
                      error={
                        hasError("name")
                          ? (!String(this.state.name || "").trim()
                            ? "Name is required"
                            : cloud.appNameSpecial)
                          : ""
                      }
                      hint="A name helps identify your cluster easily."
                    >
                      <Input
                        type="text"
                        name="name"
                        placeholder="e.g. prod-cluster-01"
                        value={this.state.name}
                        onChange={this.handleChange}
                        autoComplete="off"
                        error={hasError("name")}
                      />
                    </Field>
                    <Field label="Description" hint={cluster.descriptionInfo}>
                      <Textarea name="description" rows={3} value={this.state.description} onChange={this.handleChange} />
                    </Field>
                  </div>
                </div>
                <div style={{ padding: "12px 24px 20px", borderTop: `0.5px solid ${T.border}`, display: "flex", justifyContent: "flex-end" }}>
                  <BtnPrimary onClick={this.next}>
                    Next step <span style={{ opacity: 0.7, marginLeft: 2 }}>→</span>
                  </BtnPrimary>
                </div>
              </div>
              <InfoBox>
                <strong>Name your cluster to begin.</strong> Add a short description to identify it easily.
              </InfoBox>
            </>
          )}

          {/* ─── Step 2: Cloud config ─── */}
          {currentStep === 2 && (
            <>
              <div style={{ background: T.surface, border: `0.5px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
                <div style={{ padding: "20px 24px 16px", borderBottom: `0.5px solid ${T.border}` }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ color: T.accent }}><Ic.Cloud /></span>
                    <span style={{ fontSize: 15, fontWeight: 500 }}>Cloud configuration</span>
                  </div>
                  <p style={{ fontSize: 12, color: T.textMuted, marginTop: 4 }}>Select your cloud provider and region</p>
                </div>
                <div style={{ padding: 24 }}>
                  {/* Provider picker */}
                  <Field
                    label="Cloud Provider"
                    required
                    error={hasError("provisionerId") ? "Cloud provider is required" : ""}
                  >
                    <ProviderSelect
                      value={this.state.provisionerId || ""}
                      options={provisionerNames || []}
                      onChange={this.handleProviderChange}
                      error={hasError("provisionerId")}
                      placeholder="Select a cloud provider"
                      emptyMessage="No providers available"
                    />
                  </Field>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                    <Field
                      label="Zone"
                      required
                      error={hasError("zone") ? "Zone is required" : ""}
                      hint="Choose a zone close to your users for optimal performance."
                    >
                      <FancySelect
                        value={this.state.zone}
                        error={hasError("zone")}
                        placeholder="Select a zone"
                        options={(this.state.zoneNames || [])
                          .filter((item) => item.value !== "")
                          .map((item) => ({ value: item.value, label: item.label }))}
                        onChange={(next) => this.setState({ zone: next })}
                      />
                    </Field>
                    <Field
                      label="Compute Instance"
                      required
                      error={hasError("computeInstance") ? "Compute instance is required" : ""}
                    >
                      <FancySelect
                        value={this.state.computeInstance}
                        error={hasError("computeInstance")}
                        placeholder="Select an instance"
                        options={(this.state.instanceNames || []).filter((item) => item.value !== "")}
                        onChange={(next) => this.setState({ computeInstance: next })}
                        divided
                      />
                    </Field>
                    <Field
                      label="Number of Nodes"
                      required
                      error={hasError("nodeCount") ? "Enter at least 1 node" : ""}
                    >
                      <Input
                        type="number"
                        min="1"
                        name="nodeCount"
                        value={this.state.nodeCount}
                        onChange={this.handleChange}
                        error={hasError("nodeCount")}
                      />
                    </Field>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                        marginTop: 22,
                        padding: "10px 12px",
                        borderRadius: 10,
                        border: `0.5px solid ${T.borderMid}`,
                        background: "#f8fafc",
                      }}
                    >
                      <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: T.textPrimary }}>Enable autoscaling</div>
                        <div style={{ fontSize: 11, color: T.textMuted, marginTop: 2 }}>
                          Automatically adjust nodes based on workload
                        </div>
                      </div>
                      <button
                        type="button"
                        role="switch"
                        aria-checked={this.state.autoscale}
                        aria-label="Enable autoscaling"
                        onClick={() => this.setState((prev) => ({ autoscale: !prev.autoscale }))}
                        style={{
                          width: 44,
                          height: 24,
                          borderRadius: 999,
                          border: "none",
                          padding: 2,
                          cursor: "pointer",
                          background: this.state.autoscale ? T.accent : "#cbd5e1",
                          transition: "background 0.15s ease",
                          flexShrink: 0,
                          position: "relative",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            top: 2,
                            left: this.state.autoscale ? 22 : 2,
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            background: "#fff",
                            boxShadow: "0 1px 3px rgba(15,23,42,0.2)",
                            transition: "left 0.15s ease",
                          }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div style={{ padding: "12px 24px 20px", borderTop: `0.5px solid ${T.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <BtnSecondary onClick={this.prev}><Ic.ArrowLeft /> Previous</BtnSecondary>
                  <div style={{ display: "flex", gap: 8 }}>
                    <BtnSecondary onClick={this.next} style={{ color: T.accent, borderColor: T.accent }}>
                      Network settings →
                    </BtnSecondary>
                    <BtnPrimary onClick={this.CreateCluster} style={{ background: T.accentDark }} disabled={creating}>
                      Create cluster
                    </BtnPrimary>
                  </div>
                </div>
              </div>
              <InfoBox>{cluster.networkInfo}</InfoBox>
            </>
          )}

          {/* ─── Step 3: Network ─── */}
          {currentStep === 3 && (
            <>
              <div style={{ background: T.surface, border: `0.5px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
                <div style={{ padding: "20px 24px 16px", borderBottom: `0.5px solid ${T.border}` }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ color: T.accent }}><Ic.Shield /></span>
                    <span style={{ fontSize: 15, fontWeight: 500 }}>Network configuration</span>
                  </div>
                  <p style={{ fontSize: 12, color: T.textMuted, marginTop: 4 }}>Configure network settings and policies</p>
                </div>
                <div style={{ padding: 24 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                    <Field label="VPC ID">
                      <Input type="text" name="vpcId" placeholder="vpc-xxxxxxxx" value={this.state.vpcId} onChange={this.handleChange} autoComplete="off" />
                    </Field>
                    <Field label="Subnet ID">
                      <Input type="text" name="subnetId" placeholder="subnet-xxxxxxxx" value={this.state.subnetId} onChange={this.handleChange} autoComplete="off" />
                    </Field>
                    <Field label="Aging Policy">
                      <FancySelect
                        value={this.state.agingPolicy}
                        placeholder="Select aging policy"
                        options={[
                          { value: "TERMINATE", label: "Terminate" },
                          { value: "NEVER", label: "Never" },
                        ]}
                        onChange={(next) => this.setState({ agingPolicy: next })}
                      />
                    </Field>
                    <Field label="If Idle (hours)">
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FancySelect
                          value={this.state.idleAction}
                          placeholder="Select hours"
                          options={[...Array(36)].map((_, i) => {
                            const v = (i + 1) * 2;
                            return { value: String(v), label: String(v) };
                          })}
                          onChange={(next) => this.setState({ idleAction: next })}
                        />
                        <span style={{ fontSize: 12, color: T.textSecondary, whiteSpace: "nowrap" }}>hours</span>
                      </div>
                    </Field>
                  </div>
                </div>
                <div style={{ padding: "12px 24px 20px", borderTop: `0.5px solid ${T.border}`, display: "flex", justifyContent: "space-between" }}>
                  <BtnSecondary onClick={this.prev}><Ic.ArrowLeft /> Previous</BtnSecondary>
                  <BtnPrimary onClick={this.CreateCluster} style={{ background: T.accentDark }} disabled={creating}>
                    Create cluster
                  </BtnPrimary>
                </div>
              </div>
              <InfoBox>
                <strong>Ready to deploy your cluster?</strong> {cluster.deployNotify}
              </InfoBox>
            </>
          )}
          </div>
        </div>
      </div>
    );
  }

  /* ──────────────────────────────────────────
     RENDER: Cluster List
  ────────────────────────────────────────── */
  render() {
    if (this.state.showClusterAction) return this.renderCreateCluster();

    const { items: filteredClusters, totalPages, currentPage, totalItems } = this.getPagedClusters();

    return (
      <>
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
          .cl-cluster-card {
            background: ${T.surface};
            border: 1px solid ${T.border};
            border-radius: 12px;
            overflow: hidden;
            transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
          }
          .cl-cluster-card:hover {
            border-color: rgba(59, 130, 246, 0.28);
            box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
            transform: translateY(-1px);
          }
          .cl-cluster-card.expanded {
            background: #fafbfc;
            border-color: rgba(59, 130, 246, 0.22);
          }
          .cl-cluster-row {
            display: grid;
            grid-template-columns: ${CLUSTER_LIST_GRID_COLUMNS};
            gap: 0 12px;
            align-items: center;
            padding: 14px 16px;
            cursor: pointer;
            transition: background 0.12s ease;
          }
          .cl-cluster-head {
            display: grid;
            grid-template-columns: ${CLUSTER_LIST_GRID_COLUMNS};
            gap: 0 12px;
            align-items: center;
            padding: 0 16px 6px;
            font-size: 11px;
            font-weight: 600;
            color: ${T.textMuted};
            text-transform: uppercase;
            letter-spacing: 0.04em;
          }
          .cl-cluster-head span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .cl-sort-btn:hover { color: ${T.textPrimary} !important; }
          .cl-pagination .page-footer {
            margin-top: 0 !important;
            padding: 4px 0 !important;
            border-radius: 0;
            min-height: 0;
          }
          .cl-pagination .pagination-info {
            font-size: 11px !important;
            line-height: 1.2;
          }
          .cl-pagination .go-to-page {
            margin-top: 4px !important;
          }
          .cl-pagination .go-to-page label {
            font-size: 11px;
            color: ${T.textSecondary};
            white-space: nowrap;
          }
          .cl-pagination .go-to-page .form-control {
            height: 26px;
            font-size: 12px;
            padding: 2px 6px;
          }
          .cl-pagination .go-to-page .btn {
            height: 26px;
            padding: 0 8px;
            font-size: 11px;
            line-height: 1;
            background: #3b82f6 !important;
            border-color: #3b82f6 !important;
            color: #fff !important;
          }
          .cl-pagination .go-to-page .btn:hover,
          .cl-pagination .go-to-page .btn:focus {
            background: #2563eb !important;
            border-color: #2563eb !important;
            color: #fff !important;
          }
          .cl-pagination .pagination {
            gap: 2px;
          }
          .cl-pagination .pagination .page-link {
            padding: 2px 8px !important;
            margin: 0 !important;
            font-size: 12px;
            line-height: 1.2;
            min-width: 28px;
            height: 28px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px !important;
          }
          .cl-cluster-expand-btn {
            width: 28px;
            height: 28px;
            padding: 0;
            border: none;
            background: transparent;
            color: ${T.textSecondary};
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 7px;
          }
          .cl-cluster-expand-btn:hover {
            background: #f1f5f9;
            color: ${T.textPrimary};
          }
          .cl-col-actions {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            min-width: 0;
            gap: 8px;
          }
          .cl-action-btn:hover { background: #f1f5f9 !important; }
          .cl-action-btn.danger:hover { background: #fee2e2 !important; color: #991b1b !important; }
          .cl-refresh:hover:not(:disabled) { background: #eff6ff !important; color: #1d4ed8 !important; }
          .cl-menu-item { display: flex; align-items: center; gap: 8px; padding: 7px 14px; font-size: 12px; cursor: pointer; color: #0f172a; white-space: nowrap; transition: background 0.1s; border: none; background: transparent; width: 100%; text-align: left; font-family: inherit; }
          .cl-menu-item:hover { background: #f8fafc; }
          .cl-menu-item.danger { color: #dc2626; }
          .cl-menu-item.danger:hover { background: #fff1f2; }
          .cl-meta-chip {
            display: inline-flex;
            align-items: center;
            padding: 4px 10px;
            border-radius: 8px;
            font-size: 11px;
            font-weight: 500;
            white-space: nowrap;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid rgba(0,0,0,0.05);
          }
          .cl-expand-panel {
            padding: 14px 16px 16px;
            background: #f8fafc;
            border-top: 1px solid rgba(0,0,0,0.06);
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .cl-expand-meta {
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 12px;
          }
          .cl-expand-meta-label {
            font-size: 11px;
            font-weight: 600;
            color: ${T.textMuted};
            margin-bottom: 4px;
          }
          .cl-expand-meta-value {
            font-size: 12px;
            color: ${T.textPrimary};
            font-weight: 500;
          }
          .cl-expand-section {
            background: ${T.surface};
            border: 1px solid ${T.border};
            border-radius: 10px;
            padding: 12px 14px;
          }
          .cl-list-row--skeleton {
            pointer-events: none;
            cursor: default;
          }
          @keyframes cl-shimmer {
            0% { opacity: 0.45; }
            50% { opacity: 0.95; }
            100% { opacity: 0.45; }
          }
          .cl-skel {
            display: block;
            border-radius: 6px;
            background: linear-gradient(90deg, #eef2f7 0%, #e2e8f0 50%, #eef2f7 100%);
            background-size: 200% 100%;
            animation: cl-shimmer 1.5s ease-in-out infinite;
          }
          .cl-skel-chevron {
            width: 28px;
            height: 28px;
            border-radius: 8px;
            justify-self: start;
          }
          .cl-skel-name {
            height: 14px;
            width: 72%;
            max-width: 180px;
          }
          .cl-skel-chip {
            height: 24px;
            width: 58px;
            border-radius: 8px;
            justify-self: start;
          }
          .cl-skel-chip-sm {
            height: 24px;
            width: 36px;
            border-radius: 8px;
            justify-self: start;
          }
          .cl-skel-text {
            height: 12px;
            width: 70%;
            max-width: 110px;
            justify-self: start;
          }
          .cl-skel-action {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            justify-self: end;
          }
          @media (max-width: 1100px) {
            .cl-expand-grid { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
            .cl-expand-meta { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; }
          }
          @media (max-width: 900px) {
            .cl-cluster-head { display: none !important; }
            .cl-cluster-row { grid-template-columns: 36px 1fr !important; gap: 10px !important; }
            .cl-cluster-row > :nth-child(n+3) { grid-column: 2; }
          }
          @media (max-width: 640px) {
            .cl-expand-grid { grid-template-columns: 1fr !important; }
            .cl-expand-meta { grid-template-columns: 1fr !important; }
          }
        `}</style>

        <div style={{ fontFamily: T.fontSans, padding: "20px 24px 24px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, gap: 12, flexWrap: "wrap" }}>
            <div>
              <div style={{ fontSize: 28, fontWeight: 700, letterSpacing: "-0.02em", color: "#172033", lineHeight: 1.2 }}>Clusters</div>
              <div style={{ fontSize: 15, color: "#667085", marginTop: 6 }}>Manage Kubernetes clusters across cloud providers</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div
                style={{
                  display: "flex", alignItems: "center", gap: 8,
                  background: "#f8fafc", border: `0.5px solid ${T.borderMid}`,
                  borderRadius: 8, padding: "0 12px", height: 34, width: 220,
                }}
              >
                <span style={{ color: T.textMuted, display: "flex" }}><Ic.Search /></span>
                <input
                  type="text"
                  placeholder="Search clusters…"
                  value={this.state.searchValue}
                  onChange={this.handleSearchChange}
                  autoComplete="off"
                  style={{ border: "none", background: "transparent", fontFamily: T.fontSans, fontSize: 13, color: T.textPrimary, outline: "none", width: "100%" }}
                />
              </div>
              <SATooltip title="Refresh cluster list">
                <button
                  className="cl-refresh"
                  type="button"
                  onClick={this.refreshClusterList}
                  disabled={this.state.loading}
                  style={{
                    width: 34,
                    height: 34,
                    border: `0.5px solid ${T.borderMid}`,
                    borderRadius: 8,
                    background: T.surface,
                    cursor: this.state.loading ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: T.textSecondary,
                    opacity: this.state.loading ? 0.7 : 1,
                  }}
                >
                  <span style={{ display: "inline-flex", animation: this.state.loading ? "spin 0.8s linear infinite" : "none" }}>
                    <Ic.Refresh />
                  </span>
                </button>
              </SATooltip>
              <BtnPrimary onClick={this.showClusterActionForm}>
                <Ic.Plus /> Add cluster
              </BtnPrimary>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, gap: 8 }}>
            <span style={{ fontSize: 12, color: T.textSecondary }}>
              {this.state.loading
                ? "Loading clusters…"
                : `${totalItems} ${totalItems === 1 ? "cluster" : "clusters"}`}
            </span>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {(this.state.loading || filteredClusters.length > 0) && (
              <div className="cl-cluster-head">
                <span />
                <SortableHead label="Cluster" sortKey="name" activeKey={this.state.sortKey} sortDir={this.state.sortDir} onSort={this.handleSort} />
                <SortableHead label="Status" sortKey="status" activeKey={this.state.sortKey} sortDir={this.state.sortDir} onSort={this.handleSort} />
                <SortableHead label="Provider" sortKey="provider" activeKey={this.state.sortKey} sortDir={this.state.sortDir} onSort={this.handleSort} />
                <SortableHead label="Cost" sortKey="cost" activeKey={this.state.sortKey} sortDir={this.state.sortDir} onSort={this.handleSort} />
                <SortableHead label="Created" sortKey="created" activeKey={this.state.sortKey} sortDir={this.state.sortDir} onSort={this.handleSort} />
                <SortableHead label="Created by" sortKey="createdBy" activeKey={this.state.sortKey} sortDir={this.state.sortDir} onSort={this.handleSort} />
                <span style={{ textAlign: "right" }}>Actions</span>
              </div>
            )}

            {this.state.loading ? (
              <ClusterListSkeleton rows={5} />
            ) : filteredClusters.length > 0 ? (
              filteredClusters.map((item) => {
                const cid = item?.id || item?.name;
                const expanded = !!this.state.expandedRows[cid];
                const st = getStatusStyle(item?.clusterStatus);
                const isRunning = item?.clusterStatus?.toUpperCase() === CLUSTERSTATUS.RUNNING;
                const ddOpen = this.state.openDropdown === cid;
                const providerType = item?.provisionerInfoDTO?.provisionerType;
                const stop = (e) => e.stopPropagation();

                return (
                  <div key={cid} className={`cl-cluster-card${expanded ? " expanded" : ""}`}>
                    <div
                      className="cl-cluster-row"
                      role="button"
                      tabIndex={0}
                      onClick={() => this.toggleRow(cid)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.toggleRow(cid);
                        }
                      }}
                    >
                      <button
                        type="button"
                        className="cl-cluster-expand-btn"
                        aria-expanded={expanded}
                        aria-label={expanded ? "Collapse cluster details" : "Expand cluster details"}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.toggleRow(cid);
                        }}
                      >
                        {expanded ? <Ic.MinusSquare /> : <Ic.PlusSquare />}
                      </button>

                      <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
                        <ClusterAvatar name={item?.name} provisionerType={providerType} />
                        <div style={{ minWidth: 0, flex: 1 }}>
                          <div style={{ fontSize: 14, fontWeight: 600, color: T.textPrimary, lineHeight: 1.3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {item?.name || "Unnamed"}
                          </div>
                          <div style={{ marginTop: 4, fontSize: 11, color: T.textMuted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {item?.description?.trim() || item?.provisionerInfoDTO?.name || "Kubernetes cluster"}
                          </div>
                        </div>
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: 6, justifySelf: "start" }} onClick={stop}>
                        <span className="cl-meta-chip" style={{ background: st.bg, color: st.color, borderColor: "rgba(0,0,0,0.05)" }}>
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: st.color, flexShrink: 0, marginRight: 2 }} />
                          {convertTextToTitleCase(item?.clusterStatus)}
                        </span>
                        <SATooltip title="Refresh status">
                          <button
                            className="cl-refresh"
                            type="button"
                            onClick={(e) => this.clusterStatus(e, item?.id)}
                            style={{ width: 26, height: 26, border: `1px solid ${T.border}`, borderRadius: 7, background: T.surface, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: T.textSecondary }}
                          >
                            <Ic.Refresh />
                          </button>
                        </SATooltip>
                      </div>

                      <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                        <img
                          src={provisionerTypeLogo(providerType)}
                          alt="Provider"
                          style={{ width: 20, height: 20, objectFit: "contain" }}
                        />
                        <span style={{ fontSize: 12, color: T.textSecondary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {item?.provisionerInfoDTO?.name || providerType || "—"}
                        </span>
                      </div>

                      <div style={{ fontSize: 13, color: T.textPrimary, fontFamily: T.fontMono }}>
                        ₹{item?.cost || "0"}
                      </div>

                      <div style={{ fontSize: 12, color: T.textSecondary }}>
                        {item?.createdDate ? moment(item.createdDate).format("MMM DD, YYYY") : "—"}
                      </div>

                      <div style={{ fontSize: 12, color: T.textSecondary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {item?.createdBy || "—"}
                      </div>

                      <div className="cl-col-actions" onClick={stop}>
                        <button
                          className="cl-action-btn"
                          type="button"
                          onClick={(e) => this.toggleDropdown(e, cid)}
                          style={{ width: 32, height: 32, border: `1px solid ${T.border}`, borderRadius: 8, background: T.surface, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: T.textSecondary }}
                        >
                          <Ic.Dots />
                        </button>
                        {ddOpen && this.state.dropdownPos && createPortal(
                          <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              position: "fixed",
                              top: this.state.dropdownPos.top,
                              left: this.state.dropdownPos.left,
                              background: T.surface,
                              border: `0.5px solid ${T.borderMid}`,
                              borderRadius: 10,
                              boxShadow: "0 8px 24px rgba(0,0,0,0.14)",
                              zIndex: 10050,
                              minWidth: 168,
                              overflow: "hidden",
                              padding: "4px 0",
                            }}
                          >
                            {isRunning ? (
                              <button className="cl-menu-item danger" onClick={() => this.showActionModal("Stop", item)}>
                                <svg width="11" height="11" viewBox="0 0 10 10" fill="none"><rect x="2" y="2" width="6" height="6" rx="1" fill="currentColor"/></svg> Stop
                              </button>
                            ) : (
                              <button className="cl-menu-item" style={{ color: "#16a34a" }} onClick={() => this.showActionModal("Start", item)}>
                                <svg width="11" height="11" viewBox="0 0 10 10" fill="none"><polygon points="2,1.5 9,5 2,8.5" fill="currentColor"/></svg> Start
                              </button>
                            )}
                            {isRunning && (
                              <button className="cl-menu-item" style={{ color: T.accent }} onClick={() => this.showActionModal("Restart", item)}>
                                <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M10 2.5A5 5 0 1 1 6 1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/><polyline points="6,1 10,1 10,5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/></svg> Restart
                              </button>
                            )}
                            <button className="cl-menu-item" onClick={() => this.showActionModal("Clone", item)}>
                              <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><rect x="3.5" y="3.5" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.2"/><path d="M1.5 8.5V2a.5.5 0 0 1 .5-.5h6.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg> Clone
                            </button>
                            <div style={{ height: 1, background: T.border, margin: "4px 0" }} />
                            <button className="cl-menu-item danger" onClick={() => this.showActionModal("Delete", item)}>
                              <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><polyline points="1,3 11,3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><path d="M4,3V2h4v1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><path d="M2,3l.8 7.5h6.4L10,3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg> Delete
                            </button>
                            <button className="cl-menu-item danger" onClick={() => this.showActionModal("ForceDelete", item)}>
                              <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><polyline points="1,3 11,3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><path d="M4,3V2h4v1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><path d="M2,3l.8 7.5h6.4L10,3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><line x1="6" y1="5.5" x2="6" y2="8.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg> Force delete
                            </button>
                          </div>,
                          document.body
                        )}
                      </div>
                    </div>

                    {expanded && <ClusterExpandPanel item={item} />}
                  </div>
                );
              })
            ) : (
              !this.state.loading && (
                <div style={{ textAlign: "center", padding: "56px 24px", background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)", borderRadius: 14, border: `1px dashed ${T.borderMid}` }}>
                  <div style={{ width: 48, height: 48, borderRadius: 14, margin: "0 auto 14px", display: "flex", alignItems: "center", justifyContent: "center", background: "#eff6ff", color: T.accent }}>
                    <Ic.Server />
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 600, color: T.textPrimary, marginBottom: 6 }}>
                    {this.state.searchValue ? "No clusters found" : "No clusters yet"}
                  </div>
                  <p style={{ fontSize: 13, color: T.textSecondary, marginBottom: 18, maxWidth: 320, marginLeft: "auto", marginRight: "auto" }}>
                    {this.state.searchValue ? "Try a different search term." : "Create your first cluster to get started."}
                  </p>
                  {!this.state.searchValue && (
                    <BtnPrimary onClick={this.showClusterActionForm}>
                      <Ic.Plus /> Add cluster
                    </BtnPrimary>
                  )}
                </div>
              )
            )}

            {!this.state.loading && totalPages > 1 ? (
              <div className="cl-pagination" style={{ flexShrink: 0, paddingTop: 4 }}>
                <SAPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalItems={totalItems}
                  itemsPerPage={this.state.pageSize || 10}
                  onPageChange={this.handlePaginationClick}
                  showGoToPage
                  size="sm"
                  className="cl-pagination-bar"
                />
              </div>
            ) : null}
          </div>
        </div>

        <SAModalConfirm
          show={this.state.actionShow}
          title={this.state.actionTitle}
          message={this.state.actionmessage}
          okText="Yes, proceed"
          cancelText="Cancel"
          centered={false}
          handleOk={this.doAction}
          handleCancel={this.clearActionData}
        />
      </>
    );
  }
}

export default withNavigate(ClusterList);